import { Box, Link, Typography } from '@mui/material';
import { get } from 'lodash';
import React, { FC } from 'react';
import MUIAlert from 'src/components/ui-component/mui-alert/MUIAlert';
import { PAGES_URLS } from 'src/lib/constants/routes';
import { FormStrucItem } from 'src/lib/types/types';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
import { enumT } from '../../../../utils/helper';
import SummaryLine from '../../../ui-component/form-component/abschluss-page/SummaryLine';
import CreateForm from '../../../ui-component/form-component/create-form/CreateForm';

// import schemas
import OrgaSchema from 'src/lib/paths/organisation_FULL_Paths.json';
import PersonSchema from 'src/lib/paths/person_FULL_Paths.json';
import UserSchema from 'src/lib/paths/user_Paths.json';
const PP = PersonSchema.attributes;
const OP = OrgaSchema.attributes;
const UP = UserSchema.attributes;

const AbschlussRegistrierung: FC<{
	formValue: any;
	updateFunction: (_key: string, _value: any) => void;
	datenschutzZustimmungError: any;
	formErrorMessage: string;
	personDaten: any;
	organisationDaten: any;
	LoginDaten: any;
}> = ({ formValue, updateFunction, datenschutzZustimmungError, formErrorMessage, personDaten, organisationDaten, LoginDaten }) => {
	console.log(' in Abschluss Seite mit active step 3 formmerror message ', formErrorMessage);
	return (
		<>
			<ApplicationHeading title='Bitte überprüfen Sie Ihre Angaben:' description='' />

			{formErrorMessage && <MUIAlert infoType='error' message='Sie müssen die Datenschutzhinweise zum digitalen Antragsportal zustimmen.' />}

			{/**
			 * Ihr Profil
			 */}
			<Box sx={{ mt: '2rem' }}>
				<Typography variant='h6'>Ihr Profil</Typography>
				<SummaryLine
					label='Anrede'
					value={enumT(get(personDaten, PP.Personenbezogene_Daten_Anrede.path, '-'))}
					showErrorMessagePlaceholder={false}
				/>
				<SummaryLine label='Titel' value={get(personDaten, PP.Personenbezogene_Daten_Titel.path, '-')} showErrorMessagePlaceholder={false} />
				<SummaryLine label='Vorname' value={get(personDaten, PP.Personenbezogene_Daten_Vorname.path, '')} showErrorMessagePlaceholder={false} />
				<SummaryLine label='Nachname' value={get(personDaten, PP.Personenbezogene_Daten_Nachname.path, '')} showErrorMessagePlaceholder={false} />
				<SummaryLine
					label='E-Mail - Die Passwortvergabe wird an diese Adresse gesendet'
					value={get(personDaten, PP.Kontaktdaten_E_Mail.path, '')}
					showErrorMessagePlaceholder={false}
				/>

				<SummaryLine label='Telefon' value={get(personDaten, PP.Kontaktdaten_Telefon.path, '')} showErrorMessagePlaceholder={false} />
			</Box>

			{/**
			 * Organisationsprofil
			 */}
			<Box sx={{ mt: '2rem' }}>
				<Typography variant='h6'>Organisationsprofil</Typography>

				<SummaryLine
					label='Rechtverbindlicher Name der Organisation'
					value={get(organisationDaten, OP.Geschaeftsbezogene_Daten_Name_Der_Organisation.path)}
					showErrorMessagePlaceholder={false}
				/>

				<SummaryLine
					label='Rechtform der Organisation'
					value={enumT(get(organisationDaten, OP.Geschaeftsbezogene_Daten_Rechtsform_Der_Organisation.path))}
					showErrorMessagePlaceholder={false}
				/>

				{get(organisationDaten, OP.Unternehmensprofil_Steuernummer.path) && (
					<SummaryLine
						label='Steuernummer'
						value={get(organisationDaten, OP.Unternehmensprofil_Steuernummer.path)}
						showErrorMessagePlaceholder={false}
					/>
				)}

				{get(organisationDaten, OP.Unternehmensprofil_U_St_Id_Nr.path) && (
					<SummaryLine
						label='USt-IdNr.'
						value={get(organisationDaten, OP.Unternehmensprofil_U_St_Id_Nr.path)}
						showErrorMessagePlaceholder={false}
					/>
				)}

				<SummaryLine
					label='Straße und Hausnummer'
					value={get(organisationDaten, OP.Adressdaten_Strasse_Und_Hausnummer.path)}
					showErrorMessagePlaceholder={false}
				/>
				<SummaryLine
					label='Postleitzahl Ort'
					value={get(organisationDaten, OP.Adressdaten_PLZ.path) + ' ' + get(organisationDaten, OP.Adressdaten_Ort.path)}
					showErrorMessagePlaceholder={false}
				/>
				<SummaryLine label='E-Mail-Adresse' value={get(organisationDaten, OP.Kontaktdaten_E_Mail.path)} showErrorMessagePlaceholder={false} />
				<SummaryLine label='Telefon' value={get(organisationDaten, OP.Kontaktdaten_Telefon.path)} showErrorMessagePlaceholder={false} />
			</Box>

			{/**
			 * Ihre Zugangsdaten
			 */}
			<Box sx={{ mt: '2rem', mb: '2rem' }}>
				<Typography variant='h6'>Ihre Zugangsdaten</Typography>
				<SummaryLine label='Benutzername' value={get(LoginDaten, UP.username.path)} showErrorMessagePlaceholder={false} />
				<SummaryLine
					label='E-Mail - Die Passwortvergabe wird an diese Adresse gesendet'
					value={get(personDaten, PP.Kontaktdaten_E_Mail.path, '')}
					showErrorMessagePlaceholder={false}
				/>
			</Box>

			{/**
			 * Datenschutzhinweise
			 */}
			<Typography variant='h6' sx={{ fontWeight: 600 }}>
				Datenschutzhinweise zum digitalen Antragsportal
			</Typography>
			<Typography>
				Informationen zur Datenverarbeitung im Rahmen der Registrierung und Portalnutzung finden Sie in den{' '}
				<Link target='_blank' href={PAGES_URLS.Datenschutz}>
					Datenschutzhinweisen
				</Link>
				{'. '}
			</Typography>

			<CreateForm
				formValues={formValue}
				formStruc={formStrucDatenschutz()}
				updateFormValuesFunc={updateFunction}
				formErrors={datenschutzZustimmungError}
			/>
		</>
	);
};

export default AbschlussRegistrierung;

const formStrucDatenschutz = () => {
	const struc: FormStrucItem[] = [
		{
			fields: [
				{
					path: 'zustimmung',
					type: 'boolean',
					label: `Ich habe die Datenschutzhinweise gelesen und bin über die Datenverarbeitung im Antragsportal informiert.`,
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];

	return struc;
};
